import { PropsWithChildren } from "react";
import { TextProps } from "../data";
import { fontWeightEnum } from "../enumerations/fontWeightEnum";
import styles from "./style.module.scss";

const H4: React.FC<
  PropsWithChildren & TextProps & React.HTMLAttributes<HTMLHeadingElement>
> = ({
  children,
  weight = "normal",
  color = "rgba(0, 0, 0, 0.88)",
  ...props
}) => {
  return (
    <h4
      {...props}
      className={`${styles.h4} ${props.className}`}
      style={{
        fontWeight: fontWeightEnum[weight],
        color: color,
        ...props.style,
      }}
    >
      {children}
    </h4>
  );
};

export default H4;
